import React from 'react';
import { Box, Typography } from '@mui/material';
import { useImportWizardStore } from '../../store/useImportWizardStore';
import ColumnSelect from './ColumnSelect';

/**
 * Deal field column mapping selectors.
 * - Required: extID (marked with asterisk)
 * - Optional: name, description, notes
 *
 * Validates: Requirements 7.1, 7.2
 */
const DealFieldMapping: React.FC = () => {
  const headers = useImportWizardStore((s) => s.headers);
  const columnMappings = useImportWizardStore(
    (s) => s.mappingConfig.columnMappings
  );
  const updateMappingConfig = useImportWizardStore(
    (s) => s.updateMappingConfig
  );

  const dealFields = columnMappings?.dealFields ?? { extID: '' };

  const handleChange = (field: string, value: string) => {
    const updatedDealFields = {
      ...dealFields,
      [field]: value || undefined,
    };

    if (field === 'extID') {
      updatedDealFields.extID = value;
    }

    updateMappingConfig({
      columnMappings: {
        ...columnMappings,
        dealFields: updatedDealFields as {
          extID: string;
          name?: string;
          description?: string;
          notes?: string;
        },
      },
    });
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2 }}>
        Deal Field Mapping
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <ColumnSelect
          label="External ID"
          value={dealFields.extID || ''}
          headers={headers}
          onChange={(v) => handleChange('extID', v)}
          required
          id="deal-extid-select"
          data-testid="deal-extid-select"
        />
      </Box>
    </Box>
  );
};

export default DealFieldMapping;
